// extracted by mini-css-extract-plugin
module.exports = {"cardDisplay":"card_shuffle_cardDisplay__OQbdS","active":"card_shuffle_active__pRNMZ"};